<!-- src/app/footer/footer.component.html -->
<footer class="bg-white p-4 text-secondary bottom-0 w-full space-y-4">
  <hr class="border-gray-200 sm:mx-auto" />
  <p class="text-center">{{ "FOOTER" | translate }}</p>
</footer>
